import { render, staticRenderFns } from "./PremiumModalComponent.vue?vue&type=template&id=16553f5e&scoped=true&"
import script from "./PremiumModalComponent.vue?vue&type=script&lang=js&"
export * from "./PremiumModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./PremiumModalComponent.vue?vue&type=style&index=0&id=16553f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16553f5e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BRow, BButton, BContainer, BImg, BCol, BAvatar, BModal} from 'bootstrap-vue'
    installComponents(component, {BRow, BButton, BContainer, BImg, BCol, BAvatar, BModal})
    

export default component.exports